import { GELADA_JWT_KEYS } from '../useJwtDecoder';

const GELADA_REFRESH_TOKEN_KEYS = [...GELADA_JWT_KEYS] as const;

export { GELADA_REFRESH_TOKEN_KEYS };
